export const order = {
	orderDetails: {
		purchaseOrderNumber: 'P.O. Number',
		paymentDetails: 'Payment Details',
		freightForwarderAddress: 'Freight Forwarder',
		deliveryAddress: 'Delivery Address',
		shipTo: 'Ship To'
	}
};